import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "delete_col",
  "use": "delete_col-usage",
  "viewBox": "0 0 14 25",
  "content": "<symbol viewBox=\"0 0 14 25\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"delete_col\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.866 2.5A1 1 0 00.5 3.866l11 19.053a1 1 0 001.732-1l-11-19.053A1 1 0 00.866 2.5zM3.134.866h-.015L4.437 3.15a.997.997 0 01.697-.283h4a1 1 0 011 1v9.15l2 3.464V1.866a1 1 0 00-1-1h-8zm-1 10.294l2 3.464v7.242a1 1 0 001 1h3.758l1.155 2H3.134a1 1 0 01-1-1V11.16z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol